export default __webpack_public_path__ + "static/media/io_mobile.df30a494.png";